(() => {
  if (window.lucidiusCroMeasurement) return;
  window.lucidiusCroMeasurement = true;
  const states = new Map();
  const volumes = new Set();
  const visible = new WeakSet();
  const clicks = new WeakMap();
  const volumeKeys = new WeakMap();
  const positive = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const publish = (name, data, key, state = JSON.stringify(data)) => {
    if (states.get(key) === state) return;
    const privacy = window.Shopify?.customerPrivacy;
    const analytics = window.Shopify?.analytics;
    try {
      if (privacy?.analyticsProcessingAllowed?.() === false) return;
      if (typeof analytics?.publish === 'function') {
        Promise.resolve(analytics.publish(name, data)).catch(() => {});
      } else {
        if (privacy?.analyticsProcessingAllowed?.() !== true) return;
        (window.dataLayer ||= []).push({event:name, ...data});
      }
      states.set(key, state);
    } catch {}
  };
  const volume = element => {
    const state = element.croVolume;
    if (!state || !positive(state.product_id) || !positive(state.variant_id)) return;
    const scope = element.closest('product-info') ? 'pdp' : 'cart';
    const key = `volume:${scope}:${state.product_id}:${state.variant_id}`;
    const previous = volumeKeys.get(element);
    if (previous && previous !== key) states.delete(previous);
    volumeKeys.set(element, key);
    if (state.kind === 'none') { states.delete(key); return; }
    if (!visible.has(element) || element.hidden || !element.querySelector('p')?.textContent) return;
    const data = {product_id:Number(state.product_id), variant_id:Number(state.variant_id)};
    if (state.kind === 'nudge' && positive(state.remaining)) {
      data.remaining = Number(state.remaining);
      publish('volume_nudge_view', data, key, JSON.stringify(state));
    } else if (state.kind === 'tier' && positive(state.qty) && Number.isFinite(state.saving) && state.saving > 0) {
      data.qty = Number(state.qty);
      data.saving = state.saving;
      publish('volume_tier_reached', data, key, JSON.stringify(state));
    }
  };
  const intersection = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { visible.add(entry.target); volume(entry.target); }
    else visible.delete(entry.target);
  }));
  const search = () => {
    const result = document.querySelector('[data-cro-search]');
    const grid = document.getElementById('ProductGridContainer');
    const zero = Number(result?.dataset.resultsCount) === 0 || !!grid?.querySelector('.collection--empty:not(.loading)');
    if (result?.dataset.searchPerformed === 'true' && zero) {
      const length = Number(result.dataset.queryLength);
      if (Number.isSafeInteger(length) && length >= 0) publish('search_zero_results', {query_length:length, results:0}, 'search', String(length));
    } else if (result) states.delete('search');
  };
  const filters = new Map();
  const readFilters = () => {
    const values = new Map();
    new URLSearchParams(location.search).forEach((value, key) => {
      if (value && /^filter\.[a-z0-9_.-]+$/i.test(key)) values.set(key, [...(values.get(key) || []), value]);
    });
    return values;
  };
  readFilters().forEach((value,key) => filters.set(key, JSON.stringify(value.slice().sort())));
  const filterUpdate = () => {
    const current = readFilters();
    new Set([...filters.keys(), ...current.keys()]).forEach(key => {
      const values = current.get(key) || [];
      const state = JSON.stringify(values.slice().sort());
      if (state !== (filters.get(key) || '[]')) {
        filters.set(key, state);
        publish('filter_apply', {filter_key:key, values_count:values.filter(Boolean).length}, 'filter:' + key, state);
      }
    });
  };
  const discover = root => {
    const nodes = root.matches?.('lucidius-product-volume, lucidius-volume-nudge') ? [root] : [];
    nodes.push(...(root.querySelectorAll?.('lucidius-product-volume, lucidius-volume-nudge') || []));
    nodes.forEach(element => {
      if (volumes.has(element)) return;
      volumes.add(element);
      intersection.observe(element);
    });
    search();
  };
  discover(document);
  const insertions = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) discover(node); }));
    volumes.forEach(element => { if (!element.isConnected) { intersection.unobserve(element); volumes.delete(element); } });
  });
  insertions.observe(document.body, {subtree:true, childList:true});
  document.addEventListener('lucidius:volume-state', event => { discover(event.target); volume(event.target); });
  document.addEventListener('visitorConsentCollected', () => { search(); volumes.forEach(volume); });
  window.addEventListener('lucidius:filters-updated', filterUpdate);
  window.addEventListener('popstate', filterUpdate);
  const placement = element => element.closest('cart-drawer') ? 'drawer' : element.closest('footer, .footer, [class*="lucidius-footer"]') ? 'footer' : element.closest('header, .header') ? 'header' : element.closest('product-info') ? 'pdp' : 'page';
  document.addEventListener('click', event => {
    const element = event.target.closest?.('a, .pickup-availability-button');
    if (!element || event.defaultPrevented) return;
    const now = Date.now();
    if (now - (clicks.get(element) || 0) < 350) return;
    clicks.set(element, now);
    const source = placement(element);
    if (element.matches('[data-cro-delivery-info], .lucidius-delivery-policy a, .pickup-availability-button')) publish('delivery_info_open', {source}, 'delivery:' + source, String(now));
    if (element.tagName !== 'A') return;
    const url = new URL(element.href, location.origin);
    const type = url.protocol === 'tel:' ? 'phone' : url.protocol === 'mailto:' ? 'email' : /^(www\.|m\.)?(facebook\.com|fb\.com)$/.test(url.hostname) ? 'facebook' : null;
    if (type) publish('contact_click', {type, placement:source}, `contact:${type}:${source}`, String(now));
  }, true);
  document.addEventListener('lucidius:sticky-atc', event => {
    const id = event.detail?.product_id;
    if (positive(id)) publish('sticky_atc_click', {product_id:Number(id)}, 'sticky', String(Date.now()));
  });
})();
